module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.currentComponent),
      expression: "!currentComponent"
    }],
    staticClass: "searchbox-map-buttons"
  }, _vm._l((_vm.buttons), function(buttonGroup) {
    return _c('div', {
      staticClass: "float-box-btn-group"
    }, _vm._l((buttonGroup), function(button) {
      return _c('div', {
        staticClass: "float-box-btn",
        attrs: {
          "title": button.name
        },
        on: {
          "click": function($event) {
            _vm.callAction(button)
          }
        }
      }, [_c('i', {
        class: button.iconClass
      })])
    }))
  })), _c('div', {
    staticClass: "float-box",
    class: {
      hidden: !_vm.expanded
    },
    attrs: {
      "id": "searchbox"
    }
  }, [_c('div', {
    staticClass: "searchbox-buttons-bar"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentComponent),
      expression: "currentComponent"
    }],
    staticClass: "searchbox-btn",
    on: {
      "click": function($event) {
        _vm.toogle()
      }
    }
  }, [_c('i', {
    staticClass: "mdi",
    class: {
      'mdi-menu-left': this.expanded, 'mdi-menu-right': !this.expanded
    }
  })])]), _c('div', {
    staticClass: "searchbox-view float-box-view",
    class: {
      'level-1': _vm.registroVisivel
    }
  }, [_c('i', {
    staticClass: "action-icon mdi mdi-window-close float-box-collapse-icon",
    on: {
      "click": function($event) {
        _vm.closeComponent()
      }
    }
  }), _vm._l((_vm.viewComponents), function(comp) {
    return (comp.name === _vm.currentComponent) ? _c(comp, {
      key: comp.name,
      ref: comp.name,
      refInFor: true,
      tag: "component"
    }) : _vm._e()
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68bde998","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBox.vue
// module id = 482
// module chunks = 1